// Small searchable checkbox multi-select (replaces Botfield's react-multi-select-component).
// The list is always inline — not a floating dropdown — so it can't be clipped by the modal body.
//   options:  [{ value, label }]      selected: [value]      onChange(nextValues)

import React, { useMemo, useState } from 'react';
import './narratives.css';

export default function JobMultiSelect({ options, selected, onChange, disabled, placeholder = 'Search jobs…' }) {
  const [q, setQ] = useState('');
  const sel = useMemo(() => new Set((selected || []).map(String)), [selected]);

  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return needle ? options.filter(o => String(o.label).toLowerCase().includes(needle)) : options;
  }, [options, q]);

  function toggle(value) {
    if (disabled) return;
    const key = String(value);
    onChange(sel.has(key)
      ? (selected || []).filter(v => String(v) !== key)
      : [...(selected || []), value]);
  }

  const allShownSelected = shown.length > 0 && shown.every(o => sel.has(String(o.value)));
  function toggleShown() {
    if (disabled || shown.length === 0) return;
    if (allShownSelected) {
      const drop = new Set(shown.map(o => String(o.value)));
      onChange((selected || []).filter(v => !drop.has(String(v))));
    } else {
      const have = new Set((selected || []).map(String));
      onChange([...(selected || []), ...shown.filter(o => !have.has(String(o.value))).map(o => o.value)]);
    }
  }

  return (
    <div className={`nsx-ms${disabled ? ' nsx-ms--disabled' : ''}`}>
      <div className="nsx-ms-top">
        <input
          type="text"
          className="nsx-ms-search"
          placeholder={placeholder}
          value={q}
          disabled={disabled}
          onChange={e => setQ(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}
        />
        <button type="button" className="nsx-ms-all" onClick={toggleShown} disabled={disabled || shown.length === 0}>
          {allShownSelected ? 'Clear shown' : 'Select shown'}
        </button>
      </div>
      <div className="nsx-ms-list" role="listbox" aria-multiselectable="true">
        {shown.length === 0 ? (
          <div className="nsx-ms-empty">{options.length === 0 ? 'No jobs available.' : 'No jobs match your search.'}</div>
        ) : shown.map(o => {
          const on = sel.has(String(o.value));
          return (
            <label key={o.value} className={`nsx-ms-item${on ? ' is-on' : ''}`}>
              <input type="checkbox" checked={on} disabled={disabled} onChange={() => toggle(o.value)} />
              <span>{o.label}</span>
            </label>
          );
        })}
      </div>
      <div className="nsx-ms-foot">{sel.size} selected</div>
    </div>
  );
}
